import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'blood_glucose'

const answers: AnswerType[] = [
  {
    emoji: '🔥',
    title: 'pages.onboarding.bloodGlucose.options.diabetes',
    value: 'diabetes',
  },
  {
    emoji: '❗️',
    title: 'pages.onboarding.bloodGlucose.options.prediabetes',
    value: 'prediabetes',
  },
  {
    emoji: '✅',
    title: 'pages.onboarding.bloodGlucose.options.normal',
    value: 'normal',
  },
  {
    emoji: '❓',
    title: 'pages.onboarding.bloodGlucose.options.unknown',
    value: 'dont-know',
  },
]

export default function BloodGlucosePage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your blood glucose status?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.bloodGlucose.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
